import Form from 'react-bootstrap/Form';

function AggregatorsStatusFilterForm({ statusFilter, changeStatusFilter, spinner }) {
  return (
    <Form.Select
      className="bo-filter"
      name="filter"
      id="filter"
      placeholder="filter"
      disabled={spinner}
      value={statusFilter}
      onChange={e => changeStatusFilter('aggregators', e.target.value)}
    >
      <option value="">All Statuses</option>
      <option value="ACTIVE">Active</option>
      <option value="TERMINATED">Terminated</option>
    </Form.Select>
  );
}

export default AggregatorsStatusFilterForm;
